var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-input',{attrs:{"error":_vm.validateValue(_vm.formData),"mask":"integer","placeholder":"Ex: 300"},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }